import GuessingField from "./GuessingField.component";

export default GuessingField;
